/* ═══════════════════════════════════════════════════════════════════════════
   CASEMIRA PERF (F1 bis) - Facade du visualiseur de tapis.

   Avant : snippets/casemira-visualiseur.liquid (ex-bloc custom_liquid duplique
   dans 9 templates produit) posait en plein <body>
     <link rel="stylesheet" href="https://casemira-visualiseur.onrender.com/visualizer.css">
   Feuille tierce bloquante, sur un hebergeur a demarrage a froid : 857 -> 3 532 ms
   en 4G lente, plus 30 Ko de visualizer.js (857 -> 4 912 ms). Le parseur s'arretait
   dessus : la fiche peignait son en-tete, puis le corps arrivait d'un bloc
   (46 px -> 695 px de haut, CLS 0,0319, le plus gros decalage de la page).

   Maintenant : rien n'est demande a Render au rendu. On charge la feuille et le
   script de l'app au premier signal d'intention sur un des declencheurs, et a
   defaut en requestIdleCallback apres l'evenement load, pour que le demarrage a
   froid de Render soit absorbe avant le premier clic.

   Declencheurs (tous poses en delegation sur document, parce que .cm-viz-col-btn
   et .cm-viz-pill sont crees par casemira-pdp-reskin.js apres le rendu) :
     - .cm-viz-col-btn  : bouton de la colonne d'informations
     - .cm-viz-pill     : pastille posee sur la photo produit
     - [data-cm-open]   : le bouton d'origine, masque, cible de triggerViz()

   Un clic qui arrive avant la fin du chargement n'est pas perdu : il est rejoue
   sur [data-cm-open] des que visualizer.js est pret. L'app ecoute en delegation
   sur document, un clic synthetique suffit.
   ═══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var wrap = document.getElementById('cm-trigger-wrap');
  if (!wrap) return;

  var BASE = wrap.getAttribute('data-cm-base');
  if (!BASE) return;

  var SELECTOR = '.cm-viz-col-btn, .cm-viz-pill, [data-cm-open]';
  var IDLE = 0;
  var LOADING = 1;
  var READY = 2;
  var state = IDLE;
  var pending = [];

  function flush() {
    var fns = pending;
    pending = [];
    for (var i = 0; i < fns.length; i++) {
      try {
        fns[i]();
      } catch (e) {
        /* un rappel qui echoue ne doit pas empecher les suivants */
      }
    }
  }

  function load(callback) {
    if (state === READY) {
      if (callback) callback();
      return;
    }
    if (callback) pending.push(callback);
    if (state === LOADING) return;
    state = LOADING;

    var css = document.createElement('link');
    css.rel = 'stylesheet';
    css.href = BASE + '/visualizer.css';
    document.head.appendChild(css);

    /* visualizer.js retrouve l'origine de ses propres assets avec
       document.querySelector('script[src*="visualizer.js"]') : on garde donc
       bien le nom de fichier dans le src. */
    var js = document.createElement('script');
    js.src = BASE + '/visualizer.js';
    js.async = true;
    js.onload = function () {
      state = READY;
      flush();
    };
    js.onerror = function () {
      /* Render indisponible : on redonne sa chance au clic suivant. */
      state = IDLE;
      pending = [];
    };
    document.head.appendChild(js);
  }

  /* --- Reveil anticipe du serveur (contrat visualiseur, chantier C3) --------
     Au premier signal d'intention, en plus de charger l'app : un GET
     /api/warm?rug=<vue a plat> (204 immediat, aucun appel Gemini) pour que le
     service soit chaud ET l'image du tapis deja en cache cote serveur avant le
     clic. Une seule fois par page ; l'app reprend ensuite la main
     (window.CasemiraVision.warm) avec son propre dedoublonnage. */
  var warmed = false;
  function warm() {
    if (warmed) return;
    warmed = true;
    var real = document.querySelector('[data-cm-open]');
    var rug = real ? real.getAttribute('data-rug-image') || '' : '';
    try { if (rug) rug = new URL(rug, window.location.href).href; } catch (e) { rug = ''; }
    var url = BASE + '/api/warm' + (rug ? '?rug=' + encodeURIComponent(rug) : '');
    try {
      fetch(url, { mode: 'cors', credentials: 'omit', cache: 'no-store', keepalive: true }).catch(function () {});
    } catch (e) { /* fetch absent : l'app chauffera elle-meme */ }
  }

  /* --- Intention : survol, focus clavier, premier contact tactile ---------- */
  var hintEvents = ['pointerover', 'focusin', 'touchstart'];
  function onHint(event) {
    var target = event.target;
    if (!target || !target.closest || !target.closest(SELECTOR)) return;
    detachHints();
    warm();
    load();
  }
  function detachHints() {
    for (var i = 0; i < hintEvents.length; i++) {
      document.removeEventListener(hintEvents[i], onHint, true);
    }
  }
  for (var i = 0; i < hintEvents.length; i++) {
    document.addEventListener(hintEvents[i], onHint, { capture: true, passive: true });
  }

  /* --- Clic : on charge puis on rejoue le clic sur le bouton d'origine -----
     On arrete la propagation tant que l'app n'est pas prete. Sans cela, le
     gestionnaire pose par casemira-pdp-reskin.js sur .cm-viz-col-btn et
     .cm-viz-pill (triggerViz -> .cm-trigger.click()) declencherait un second
     passage ici, donc une seconde ouverture de la modale. */
  var replayQueued = false;
  document.addEventListener(
    'click',
    function (event) {
      if (state === READY) return; /* l'app gere elle-meme, en delegation */
      var target = event.target;
      if (!target || !target.closest) return;
      if (!target.closest(SELECTOR)) return;
      event.preventDefault();
      event.stopPropagation();
      detachHints();
      warm();
      if (replayQueued) return;
      replayQueued = true;
      load(function () {
        replayQueued = false;
        var real = document.querySelector('.cm-trigger[data-cm-open]') || document.querySelector('[data-cm-open]');
        if (real) real.click();
      });
    },
    true
  );

  /* --- Ouverture demandee depuis la collection : ?visualiser=1 -------------
     VAGUE 12, point 4. Les cartes de la grille de collection portent une entree
     vers le visualiseur (« Voir chez vous » dans le bandeau de formats sur
     ordinateur, pastille maison au telephone) : elles menent a la fiche avec
     `?visualiser=1`, et c'est ici que le parametre est lu.

     TROIS PRECAUTIONS, dans cet ordre.

     1. APRES `load`, JAMAIS AVANT. Le LCP de la fiche est la photo du heros.
        Demander 30 Ko de script tiers et une feuille de style a un hebergeur a
        demarrage a froid pendant que cette photo se peint, c'est exactement le
        defaut que cette facade a ete ecrite pour supprimer (F1 bis, CLS 0,0319).
        L'ouverture attend donc que la page ait fini de charger. Le visiteur
        arrive de la collection : il a vu la fiche pendant sa transition, une
        modale qui s'ouvre une demi-seconde plus tard se lit comme une reponse,
        pas comme une lenteur.

     2. LE CLIC EST REJOUE SUR LE VRAI BOUTON, comme celui d'un visiteur. On ne
        cherche pas a appeler une fonction interne de `visualizer.js` : l'app
        ecoute en delegation sur `document` avec `closest('[data-cm-open]')`, et
        `.cm-trigger` porte deja tous les attributs `data-*` qu'elle attend. Un
        seul chemin d'ouverture pour les deux origines, donc un seul chemin a
        maintenir.

     3. L'URL EST NETTOYEE APRES L'OUVERTURE, PAS AVANT. Si Render est
        indisponible, `js.onerror` remet l'etat a IDLE et vide la file : le
        rappel ne s'execute pas, le parametre RESTE dans l'URL, et un
        rechargement retente. Nettoyer d'entree aurait transforme une panne
        passagere en page morte. `replaceState` (et non `pushState`) : le
        parametre etait une instruction, pas une etape de navigation - le bouton
        retour doit ramener a la collection, pas a la meme fiche. */
  function askedByUrl() {
    try {
      return new URL(window.location.href).searchParams.get('visualiser') === '1';
    } catch (e) {
      return false;
    }
  }

  function stripParam() {
    try {
      var u = new URL(window.location.href);
      if (!u.searchParams.has('visualiser')) return;
      u.searchParams.delete('visualiser');
      var q = u.searchParams.toString();
      window.history.replaceState(
        window.history.state,
        '',
        u.pathname + (q ? '?' + q : '') + u.hash
      );
    } catch (e) {
      /* Un navigateur sans History API garde le parametre : sans consequence. */
    }
  }

  function autoOpen() {
    if (!askedByUrl()) return;
    detachHints();
    load(function () {
      var real =
        document.querySelector('.cm-trigger[data-cm-open]') ||
        document.querySelector('[data-cm-open]');
      if (real) real.click();
      stripParam();
    });
  }

  if (document.readyState === 'complete') autoOpen();
  else window.addEventListener('load', autoOpen, { once: true });

  /* --- Filet : preparation hors chemin critique, apres load ---------------- */
  function warmUp() {
    if (state !== IDLE) return;
    var conn = navigator.connection;
    if (conn && (conn.saveData || /2g/.test(conn.effectiveType || ''))) return;
    load();
  }
  function scheduleWarmUp() {
    if (window.requestIdleCallback) {
      window.requestIdleCallback(warmUp, { timeout: 4000 });
    } else {
      setTimeout(warmUp, 2000);
    }
  }
  if (document.readyState === 'complete') scheduleWarmUp();
  else window.addEventListener('load', scheduleWarmUp, { once: true });
})();
